module.exports = __webpack_public_path__ + "media/images/event/image_06-d679470ba82f97551910eeeda0b27425.png";